import { render, staticRenderFns } from "./allDataPageList.vue?vue&type=template&id=f0a91dae"
import script from "./allDataPageList.vue?vue&type=script&lang=js"
export * from "./allDataPageList.vue?vue&type=script&lang=js"
import style0 from "./allDataPageList.vue?vue&type=style&index=0&id=f0a91dae&prod&lang=css"
import style1 from "./allDataPageList.vue?vue&type=style&index=1&id=f0a91dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports